/* HFB-071 — Shop by Benefit renders in the section. JS only places the sold line and the mobile gallery. */
(function () {
  function place() {
    var mount = document.querySelector("[data-hfb-071-mount]");
    if (!mount) return;

    var sold = mount.querySelector(".hfb-071-sold");
    var title = document.querySelector(".product-main-form h1.product-main-title");
    if (sold && title && !sold.classList.contains("is-placed")) {
      var oldSold = document.querySelectorAll(".hfb-071-sold.is-placed");
      for (var s = 0; s < oldSold.length; s++) oldSold[s].remove();
      title.insertAdjacentElement("afterend", sold);
      sold.classList.add("is-placed");
    }
  }

  function mountPeek() {
    if (window.innerWidth > 959) return;
    var gallery = document.querySelector(".product__gallery.layout--main");
    if (!gallery || gallery.querySelector(".hfb-071-peek")) return;

    var sources = gallery.querySelectorAll(".gallery__main-images .gallery__image img");
    if (!sources.length) return;

    var peek = document.createElement("div");
    peek.className = "hfb-071-peek";
    var track = document.createElement("div");
    track.className = "hfb-071-peek__track";
    var dots = document.createElement("div");
    dots.className = "hfb-071-peek__dots";
    dots.setAttribute("role", "tablist");
    dots.setAttribute("aria-label", "Product images");

    for (var i = 0; i < sources.length; i++) {
      var slide = document.createElement("div");
      slide.className = "hfb-071-peek__slide";
      slide.setAttribute("role", "group");
      slide.setAttribute("aria-label", "Image " + (i + 1) + " of " + sources.length);
      var img = document.createElement("img");
      img.src = sources[i].currentSrc || sources[i].src;
      img.alt = sources[i].alt || "";
      if (i === 0) img.setAttribute("fetchpriority", "high");
      slide.appendChild(img);
      track.appendChild(slide);

      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "hfb-071-peek__dot" + (i === 0 ? " is-active" : "");
      dot.setAttribute("role", "tab");
      dot.setAttribute("aria-label", "Show image " + (i + 1) + " of " + sources.length);
      dot.setAttribute("aria-selected", i === 0 ? "true" : "false");
      dot.setAttribute("data-index", String(i));
      dots.appendChild(dot);
    }

    peek.appendChild(track);
    peek.appendChild(dots);
    gallery.insertBefore(peek, gallery.firstChild);

    function setActive(index) {
      var buttons = dots.querySelectorAll(".hfb-071-peek__dot");
      for (var d = 0; d < buttons.length; d++) {
        var on = d === index;
        buttons[d].classList.toggle("is-active", on);
        buttons[d].setAttribute("aria-selected", on ? "true" : "false");
      }
    }

    function step() {
      var slides = track.children;
      if (!slides.length) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function indexFromScroll() {
      var slides = track.children;
      var width = step();
      if (!slides.length || !width) return 0;
      var index = Math.round(track.scrollLeft / width);
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      return index;
    }

    var frame = 0;
    track.addEventListener("scroll", function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        setActive(indexFromScroll());
      });
    }, { passive: true });

    dots.addEventListener("click", function (event) {
      var button = event.target.closest(".hfb-071-peek__dot");
      if (!button) return;
      var index = parseInt(button.getAttribute("data-index"), 10) || 0;
      var slides = track.children;
      if (!slides[index]) return;
      track.scrollTo({ left: index * step(), behavior: "smooth" });
      setActive(index);
    });
  }

  function keepPreviewParams() {
    var view = new URLSearchParams(window.location.search).get("view");
    if (view !== "body-washes-v1" && view !== "body-washes-title") return;
    var links = document.querySelectorAll(".hfb-071__card");
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute("href");
      if (!href) continue;
      var url;
      try {
        url = new URL(href, window.location.origin);
      } catch (e) {
        continue;
      }
      if (!url.searchParams.get("view")) url.searchParams.set("view", view);
      links[i].setAttribute("href", url.pathname + url.search + url.hash);
    }
  }

  function scrollCurrentCard() {
    if (window.innerWidth > 959) return;
    var row = document.querySelector(".hfb-071__row");
    var current = row && row.querySelector(".hfb-071__card--current");
    if (!row || !current) return;
    var rowRect = row.getBoundingClientRect();
    var cardRect = current.getBoundingClientRect();
    if (!rowRect.width || !cardRect.width) return;
    var pad = 15;
    var next = row.scrollLeft;
    if (cardRect.right > rowRect.right - 8) {
      next += cardRect.right - rowRect.right + pad;
    } else if (cardRect.left < rowRect.left + pad) {
      next += cardRect.left - rowRect.left - pad;
    }
    var max = row.scrollWidth - row.clientWidth;
    if (next < 0) next = 0;
    if (next > max) next = max;
    row.scrollLeft = next;
  }

  function sync() {
    place();
    keepPreviewParams();
    mountPeek();
    window.requestAnimationFrame(scrollCurrentCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sync);
  } else {
    sync();
  }

  var peekQuery = window.matchMedia("(max-width: 959px)");
  function onViewport() {
    mountPeek();
    scrollCurrentCard();
  }
  if (peekQuery.addEventListener) peekQuery.addEventListener("change", onViewport);
  else if (peekQuery.addListener) peekQuery.addListener(onViewport);

  document.addEventListener("shopify:section:load", sync);
  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target;
    if (!section || !section.querySelector || !section.querySelector("[data-hfb-071-mount]")) return;
    var sold = document.querySelectorAll(".hfb-071-sold.is-placed");
    for (var j = 0; j < sold.length; j++) sold[j].remove();
    var peek = document.querySelector(".hfb-071-peek");
    if (peek) peek.remove();
  });
})();
